import React from 'react';
import Image from 'react-bootstrap/Image'
import {Col, Container, Row} from 'react-bootstrap';
import Tree from './trees-game.png'

export const TreesGame = () => {
    return <div>
        <Container>
            <Row>
                <h4>Quarantine Project: Photosynthesis</h4>
            </Row>
            <Row>
                <Col xs={6}>
                    A wonderful <a href="https://www.amazon.com/Blue-Orange-Games-Photosynthesis-Strategy/dp/B074K5W5N5/ref=sr_1_2?crid=24LNH0NN4FP3S&dchild=1&keywords=photosynthesis+board+game&qid=1606101325&sprefix=photosynthesis%2Caps%2C265&sr=8-2">board game</a>,
                    a goal for this quarantined winter is to make "trees chess" playable online.
                    <br /><br />
                    What might I learn from this project?
                    <ul>
                        <li>React DnD, a more natural user interface</li>
                        <li>There might be some opportunity for doing low-compute AI</li>
                        <li>Running a large-scale web application</li>
                        <li>Most importantly, I will be able to lose to my friends in this again</li>
                    </ul>
                    <br />
                    One early discovery: don't try to do something like polar coordinates, rather,
                    put everything as rows with CSS to offset by row number, and have an X-Y coordinate system centered at the board's center.
                </Col>
                <Col xs={6}>
                    <Row>
                        <Image src={Tree} style={{height: '400px'}}/>
                    </Row>
                    <Row>
                        ..a work in in progress..
                    </Row>
                </Col>
            </Row>
        </Container>

    </div>;
}